import { VabsParticipantType, VabsPaymentSystem } from '@/shared/api';
import { Human } from '@/shared/assets';
import { AvatarWithIndicator, Typography } from '@/shared/ui';

import { PAYMENT_INDICATORS } from '../lib/indicators';
import { IPaymentTemplate } from '../lib/serialize';

interface PaymentCardProps {
  payment: IPaymentTemplate;
  onClick?: VoidFunction;
}
export const PaymentCard = ({ payment, onClick }: PaymentCardProps) => {
  const indicator = PAYMENT_INDICATORS[payment.direction];
  return (
    <div
      className="flex cursor-pointer items-center rounded-[20px] px-5 hover:bg-hover-base-500-hover"
      onClick={onClick}
    >
      <AvatarWithIndicator
        indicator={indicator}
        className="py-4 pr-4"
        defaultAvatar={
          <div className="flex h-10 w-10 items-center justify-center rounded-full bg-base-300">
            <Human className="h-6 w-6" />
          </div>
        }
        avatar=""
      />
      <div className="flex w-[271px] flex-col gap-1">
        <Typography
          variant="16-r"
          className="overflow-hidden text-ellipsis whitespace-nowrap"
        >
          {payment.type === VabsParticipantType.B2C &&
            `${payment.firstName || '-'} ${payment.lastName || ''}`}
          {payment.type === VabsParticipantType.B2B && payment.companyName}
          {payment.paymentSystem === VabsPaymentSystem.Inner && payment.name}
        </Typography>
        <Typography variant="14-r" color="text-base-100">
          {payment.accountNumber}
          {payment.paymentSystem === VabsPaymentSystem.Inner && 'FCB account'}
        </Typography>
      </div>
    </div>
  );
};
